import styled, { css } from 'styled-components';
import { PimImage } from 'src/components/common/PimImage';
import { ProductDTO } from 'src/models/pim';
import { useEffect, useState } from 'react';
import SwiperClass from 'swiper/types/swiper-class';
import { Swiper, SwiperSlide } from 'swiper/react';
import { casePathEmptyString } from 'src/utils/casePathEmptyString';
import { media } from 'src/styles/designs';
import { useMediaQuery } from 'src/hooks/useMediaQuery';

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 12px;

  ${media.w.greaterThanOrEqual.desktop} {
    flex-direction: row;
  }
`;

const ThumbnailsSwiper = styled(Swiper)`
  width: 100%;
  height: 77px;

  .swiper-slide {
    width: 77px;
    height: 77px;
    margin-right: 8px;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    width: 87px;
    height: 410px;

    .swiper-slide {
      width: 87px;
      height: 87px;
      margin-bottom: 8px;
    }
  }
`;

const Thumnbail = styled.div<{ $active?: boolean }>`
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3rpx;
    background: ${({ theme }) => theme.palette.accent};
    transition: 0.25s;
    transform-origin: 0% 50%;
    transform: scaleX(0);
  }

  ${casePathEmptyString('$active')(css`
    &::after {
      transform: scaleX(1);
    }
  `)}
`;

const SwiperContainer = styled(Swiper)`
  width: 335px;
  height: 335px;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 430px;
    height: 430px;
  }
`;

export const ProductPageShowcaseGallery = (product: ProductDTO) => {
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [thumbnailSwiper, setThumbnailSwiper] = useState<SwiperClass | null>(
    null,
  );

  const isDesktop = useMediaQuery(media.w.greaterThanOrEqual.desktop);

  const [activeIndex, setActiveIndex] = useState(0);

  const images = product.image ? [product.image] : [];

  useEffect(() => {
    if (swiper && thumbnailSwiper) {
      swiper.slideTo(activeIndex);
      thumbnailSwiper.slideTo(activeIndex);
    }
  }, [swiper, thumbnailSwiper, activeIndex]);

  return (
    <Container>
      {images.length > 1 && (
        <ThumbnailsSwiper
          direction={isDesktop ? 'vertical' : 'horizontal'}
          slidesPerView="auto"
          onSwiper={setThumbnailSwiper}
          onSlideChange={(s) => setActiveIndex(s.activeIndex)}
        >
          {images?.map((image, i) => (
            <SwiperSlide key={image.id + i} onClick={() => setActiveIndex(i)}>
              <Thumnbail $active={activeIndex === i}>
                <PimImage src={image.id} layout="fill" objectFit="contain" />
              </Thumnbail>
            </SwiperSlide>
          ))}
        </ThumbnailsSwiper>
      )}

      <SwiperContainer
        slidesPerView={1}
        onSwiper={setSwiper}
        onSlideChange={(s) => setActiveIndex(s.activeIndex)}
      >
        {images?.map((image, i) => (
          <SwiperSlide key={image.id + i}>
            <PimImage
              src={image.id}
              layout="fill"
              objectFit="contain"
              sizes="100vw"
            />
          </SwiperSlide>
        ))}
      </SwiperContainer>
    </Container>
  );
};
